<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36.015"
      height="13.29"
      viewBox="0 0 36.015 13.29"
    >
      <path
        id="Icon_material-phone-missed"
        data-name="Icon material-phone-missed"
        d="M35.565,25A25.525,25.525,0,0,0,.435,25a1.521,1.521,0,0,0,0,2.13l3.72,3.72a1.5,1.5,0,0,0,1.065.435,1.539,1.539,0,0,0,1.05-.42,17.128,17.128,0,0,1,3.99-2.775,1.494,1.494,0,0,0,.84-1.35v-4.65A21.936,21.936,0,0,1,18,21a22.366,22.366,0,0,1,6.9,1.08v4.65a1.511,1.511,0,0,0,.84,1.35,17.682,17.682,0,0,1,4,2.775,1.473,1.473,0,0,0,1.05.42,1.5,1.5,0,0,0,1.065-.435l3.72-3.72a1.5,1.5,0,0,0,.435-1.065,1.473,1.473,0,0,0-.45-1.05Z"
        transform="translate(0 -18)"
        fill="#fff"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
  },
  data() {
    return {};
  },
};
</script>